import {
  faAddressCard,
  faArrowLeft,
  faBars,
  faBullseye,
  faCaretDown,
  faCaretUp,
  faChartArea,
  faChartLine,
  faCogs,
  faCompress,
  faCrosshairs,
  faDesktop,
  faDollarSign,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faGamepad,
  faGift,
  faGraduationCap,
  faHourglassHalf,
  faKey,
  faListOl,
  faMedal,
  faNewspaper,
  faPencilAlt,
  faQuestion,
  faRandom,
  faShare,
  faSignOutAlt,
  faStar,
  faStoreAlt,
  faTicketAlt,
  faTimesCircle,
  faTrash,
  faTrophy,
  faUserAlt,
  faUserSecret,
  faVolumeUp,
} from '@fortawesome/free-solid-svg-icons'
import { faClock, faTimesCircle as faTimesCircleO, } from '@fortawesome/free-regular-svg-icons'
import { faFortAwesome, faGrav, } from '@fortawesome/free-brands-svg-icons'

export default [
  faAddressCard,
  faArrowLeft,
  faBars,
  faBullseye,
  faCaretDown,
  faCaretUp,
  faChartArea,
  faChartLine,
  faCogs,
  faCompress,
  faClock,
  faCrosshairs,
  faDesktop,
  faDollarSign,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faFortAwesome,
  faGamepad,
  faGift,
  faGraduationCap,
  faGrav,
  faHourglassHalf,
  faKey,
  faListOl,
  faMedal,
  faNewspaper,
  faPencilAlt,
  faQuestion,
  faRandom,
  faShare,
  faSignOutAlt,
  faStar,
  faStoreAlt,
  faTicketAlt,
  faTimesCircle,
  faTimesCircleO,
  faTrash,
  faTrophy,
  faUserAlt,
  faUserSecret,
  faVolumeUp,
]



// WEBPACK FOOTER //
// ./src/app/const/icons.js